export enum OrderType {
    Sales = "Sales",
    Service = "Service"
}
